export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/680273bf09bfd3a8fc34474ae0d0eb37.svg";